import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router';
import { HashRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import ErrorPage from '../pages/error';

import '../styles/theme.scss';
import LayoutComponent from '../components/Layout';
//import DocumentationLayoutComponent from '../documentation/DocumentationLayout';
import Login from '../pages/login';
import Register from '../pages/register';
import { logoutUser } from '../actions/user';

const PrivateRoute = ({dispatch, component, isAuthenticated, ...rest }) => {
    console.log('PrivateRoute - isAuthenticated:', isAuthenticated);
    if (!isAuthenticated) {
        console.log('PrivateRoute - redirecting to login');
        dispatch(logoutUser());
        return (<Redirect to="/login"/>)
    } else {
        console.log('PrivateRoute - allowing access');
        return ( // eslint-disable-line
            <Route {...rest} render={props => (React.createElement(component, props))}/>
        );
    }
};

const CloseButton = ({ closeToast }) => (
  <button type="button" className="toast-close-btn" onClick={closeToast} aria-label="Dismiss notification">
    &times;
  </button>
);

class App extends React.PureComponent {
  render() {
    return (
        <div>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                draggable
                pauseOnHover
                limit={5}
                toastClassName="unloadin-toast"
                bodyClassName="unloadin-toast-body"
                progressClassName="unloadin-toast-progress"
                closeButton={<CloseButton />}
            />
            <HashRouter>
                <Switch>
                    <Route path="/" exact render={() => <Redirect to="/app/operations-dashboard"/>}/>
                    <Route path="/app" exact render={() => <Redirect to="/app/operations-dashboard"/>}/>
                    <PrivateRoute path="/app" dispatch={this.props.dispatch} component={LayoutComponent} isAuthenticated={this.props.isAuthenticated}/>
                    <Route path="/documentation" exact
                           render={() => <Redirect to="/documentation/getting-started/overview"/>}/>
                    {/* <Route path="/documentation" component={DocumentationLayoutComponent}/> */}
                    <Route path="/register" exact component={Register}/>
                    <Route path="/login" exact component={Login}/>
                    <Route path="/error" exact component={ErrorPage}/>
                </Switch>
            </HashRouter>
        </div>

    );
  }
}

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(App);
